<template>
  <section id="lm-process-actions">
    <div class="row">
      <div class="col-12">
        <h4>{{ $t('who_can_make_passes_to_this_group') }}</h4>
        <p class="mb-3">{{ $t('select_who_can_make_passes_to_this_group') }}</p>
        <div class="row">
          <div class="col-6">
            <div class="row">
              <div class="col-auto d-flex align-items-end" style="margin-top: -1px;">
                <LmTreeSelect
                  :disabled="disabled"
                  class="mr-4"
                  :label="$t('areas')"
                  clearable
                  pathToGetOptions="/customer/areas"
                  v-model="actionsData.area"
                />
                <LmButton
                  :disabled="!actionsData.area"
                  buttonClass="btn-primary"
                  @click="onAdd('area')"
                  :value="$t('add')"
                />
              </div>
              <div class="col-auto d-flex align-items-end">
                <LmTreeSelect
                  class="mr-4"
                  :label="$t('users')"
                  clearable
                  pathToGetOptions="/users/all"
                  v-model="actionsData.user"
                />
                <LmButton
                  :disabled="!actionsData.user"
                  buttonClass="btn-primary"
                  @click="onAdd('user')"
                  :value="$t('add')"
                />
              </div>
            </div>
          </div>

          <div class="col-6">
              <b-list-group v-if="actions.length">
                <b-list-group-item v-for="(item, index) of actions" :key="index">
                  <div class="d-flex align-items-center justify-space-between">
                    <div class="d-flex align-items-center w-50">
                      <i
                        style="font-size: 20px"
                        class="mr-2 mdi"
                        :class="`mdi-${item.icon}`"
                      />
                      <span>
                        {{ item.name }}
                      </span>
                    </div>
                    <div class="d-flex justify-content-end align-items-center w-50">
                      <i
                        v-if="!disabled"
                        style="font-size: 20px"
                        class="mx-2 clickable mdi mdi-close"
                        @click="onDelete(item)"
                      />
                    </div>
                  </div>
                </b-list-group-item>
              </b-list-group>
              <div v-else>
                <LmSvgIcon
                  icon="LmNoDataIcon"
                  width="7.5em"
                  wrapperClass="mb-4 d-flex justify-content-center"
                />
                <p class="text-center">
                  {{ $t('permits_have_not_been_selected_for_the_procedures') }}
                </p>
              </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmRadio from '@/components/form/elements/LmRadio'
import LmButton from '@/components/form/elements/LmButton'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmTreeSelect,
    LmRadio,
    LmButton
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      actionsData: {
        area: null,
        user: null
      },
      editAction: 'destinationArea',
      editActionDetail: null
    }
  },
  computed: {
    actions () {
      let items = []
      for (const key in this.value) {
        const arr = this.value[key].map(el => {
          return {
            ...el,
            group: key,
            icon: this.setIcon(key)
          }
        })
        items = items.concat(arr)
      }
      return items
    },
    userOptions () {
      // options: all or allexceptme
      return `/users/all`
    }
  },
  methods: {
    setIcon (type) {
      const icons = {
        area: 'domain',
        user: 'account-group'
      }
      return icons[type]
    },
    clearData (prop) {
      this.actionsData[prop] = null
    },
    onDelete (item) {
      this.value[item.group] = this.value[item.group].filter(el => el.id !== item.id)
    },
    onAdd (type) {
      if (this.value[type].some(val => val.id === this.actionsData[type].id)) {
        this.clearData(type)
        this.lmToastDangerMessage('No se agregaron los privilegios duplicados.', 'Destinatario duplicado')
        return
      }
      this.value[type].push({
        ...this.actionsData[type],
        action: 'S',
        role: null
      })
      this.clearData(type)
    },
    clearUser () {
      if (this.actionsData.user) {
        this.actionsData.user = null
      }
    },
    onSetStartAction (id, group) {
      this.value[group].find(el => el.id === id).action = 'S'
    },
    onSetRequestStartAction (id, group) {
      this.value[group].find(el => el.id === id).action = 'RS'
    },
    onSetRoleAction (id, group, index) {
      this.value[group].find(el => el.id === id).role = this.actions[index].role
    }
  }
}
</script>

<style>
#lm-process-actions {
  margin-bottom: 110px;
}

#lm-process-actions .btn.dropdown-toggle:focus {
  outline: none;
  box-shadow: none;
}

#lm-process-actions .role-select {
  margin-bottom: 0px !important;
}
</style>
